<div class="outer">
  <div class="wrapper">
    <div class="header">
      {{title}}
      <button mat-dialog-close class="close-btn" (click)="closeDialog(false)"
        matTooltip="{{'businessTexts.close' | translate}}">
        <cqes-icon icon="close" class="close-icon"></cqes-icon>
      </button>
    </div>
    <div class="content">
      <form *ngIf="groupForm" [formGroup]="groupForm" class="input">
        <mat-form-field>
          <mat-label>{{'businessTexts.groupName' | translate}}</mat-label>
          <input matInput type="text" id="name" formControlName="name">
          <mat-error>
            {{'validationTexts.requiredField' | translate }}
          </mat-error>
        </mat-form-field>
  
        <mat-card>
          <div class="service-title">
            {{'businessTexts.chooseServices' | translate}} :
          </div>
          <ng-container formArrayName="services">
            <div *ngFor="let service of companyServices; let i = index" [compareWith]="compareServiceObjects">
              <mat-checkbox *ngIf="service.serviceType !== 'REPORTS'" color="primary" (change)="onCheckChange($event, service)" [checked]="isChecked(service)">
                <span> {{getServiceName(service)}}</span>
              </mat-checkbox>
            </div>
          </ng-container>
        </mat-card>
  
        <div class="spinner-container" *ngIf="!loaded">
          <mat-spinner class="content-box"></mat-spinner>
        </div>
  
        <div class="table">
          <cloud-business-users-table *ngIf="loaded" [tableName]="'inGroupDialog'" [group]="editedGroup"
            [inputValue]="asyncInputValue" (check)="onCheckFunction($event)"></cloud-business-users-table>
        </div>
      </form>
    </div>
  
    <div class="button-container">
      <button mat-raised-button mat-dialog-close color="primary" (click)="closeDialog(false)">{{'businessTexts.cancel' |
        translate}}</button>
      <button mat-raised-button color="primary" (click)="onSave()"
        [disabled]="!groupForm.valid && !groupForm.dirty">{{getButtonLabel()}}</button>
    </div>
  
  </div>

</div>
